import { STATUSES } from "@/lib/api";

export const StatusBadge = ({ status }) => {
  const s = STATUSES[status] || STATUSES.attivo;
  return <span className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.cls}`}>{s.label}</span>;
};

export const PageHeader = ({ eyebrow, title, desc, actions }) => (
  <div className="fade-up flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
    <div>
      {eyebrow && <div className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-2">{eyebrow}</div>}
      <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight" data-testid="page-title">{title}</h1>
      {desc && <p className="mt-2 text-slate-400 max-w-2xl">{desc}</p>}
    </div>
    {actions && <div className="flex gap-2">{actions}</div>}
  </div>
);

export const StatCard = ({ label, value, icon: Icon, testid, delay = 0 }) => (
  <div className="fade-up rounded-lg bg-[#111827] border border-slate-800/80 p-5" style={{ animationDelay: `${delay}ms` }} data-testid={testid}>
    <div className="flex items-center justify-between text-slate-500">
      <span className="text-xs uppercase tracking-wider">{label}</span>
      {Icon && <Icon size={16} />}
    </div>
    <div className="mt-3 font-display text-3xl font-semibold text-slate-100">{value}</div>
  </div>
);

export const Panel = ({ title, children, action, testid }) => (
  <section className="fade-up rounded-lg bg-[#111827] border border-slate-800/80" data-testid={testid}>
    {title && (
      <div className="flex items-center justify-between px-5 py-4 border-b border-slate-800">
        <h3 className="font-medium">{title}</h3>
        {action}
      </div>
    )}
    <div>{children}</div>
  </section>
);

export const Empty = ({ text }) => <div className="px-5 py-10 text-center text-sm text-slate-500">{text}</div>;
